<div class="main-page">
    <div class="container">
        <ngx-spinner></ngx-spinner>
        <div class="plans-area">
            <div class="innerPage plans-area-inner">
                <div class="pc-list-header">
                  <div>
                    <div class="pc-list-title">
                      <span class="pc-list-title-icon" aria-hidden="true"><i class="fa fa-envelope-open-text"></i></span>
                      My Customer Postcards
                    </div>
                    <div class="pc-list-subtitle">Your latest announcements sent to customers</div>
                  </div>
                  <button (click)="createPost()" class="pc-list-create">
                    <i class="fa fa-plus" aria-hidden="true"></i>
                    Create
                  </button>
                </div>
                <div class="my-lg-5" *ngIf="announcemnts.length<=0">
                    <img class="no-data-icon" src="../../assets/no-data.png" alt="">
                    <br>
                    <span class="text-white font-weight-bold">
                        No Record Found
                    </span>
                </div>
                <div class="pc-list" *ngIf="announcemnts.length>0">
                  <div *ngFor="let announcemnt of announcemnts; let i = index" class="pc-item" [style.animation-delay]="(i * 0.03) + 's'">
                    <div class="pc-avatar">
                      <img
                        class="pc-avatar-img"
                        [src]="(announcemnt?.createdBy?.photo | merchantProfilePhoto)"
                        (error)="onImgError($event)"
                        alt="avatar"
                      />
                    </div>
                    <div class="pc-content">
                      <div class="pc-row">
                        <div class="pc-label">
                          <i class="fa fa-tag" aria-hidden="true"></i> Title
                        </div>
                        <div class="pc-value pc-title-text">{{ announcemnt.name }}</div>
                      </div>

                      <div class="pc-row">
                        <div class="pc-label">
                          <i class="fa fa-align-left" aria-hidden="true"></i> Description
                        </div>
                        <div class="pc-value pc-desc-text">{{ announcemnt.description }}</div>
                      </div>

                      <div class="pc-row pc-row--meta">
                        <div class="pc-label">
                          <i class="fa-solid fa-calendar-days" aria-hidden="true"></i>
                          Created At
                        </div>
                        <div class="pc-value pc-date">
                          {{ announcemnt.createdAt | date:"MMM dd, yyyy 'at' hh:mm a" }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
        </div>
    </div>